<template>
  <div :class="(props.child)?'graph-item is-child':'graph-item'">
    <div class="graph__wrap-s">
      <p class="graph__subtitle">
        {{ data.label }}
        <span v-if="data.avg || data.avg_label" :style="avgPar">
          (
          <span v-if="data.avg_label">{{ data.avg_label }}</span>
          <span v-if="data.avg">{{ avgValue }}円</span>
          )
        </span>
      </p>
      <p class="graph__amount">
        <strong>{{ parseInt(data.value.value).toLocaleString() }}</strong>円
      </p>
    </div>
    <div class="range">
      <input
          ref="inputRange"
          type="range"
          step="1000"
          min="0"
          :max="data.max.value"
          v-model="data.value.value"
      >
    </div>
    <div v-if="childTypes">
      <div class="range-child">
        <span @click="toggleDetail" class="range-child__head">細かく設定する</span>
        <div class="range-child__body">
          <div v-for="type in childTypes">
            <Range :type="type" :child="true"></Range>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import {computed, onMounted, onUpdated, ref} from "vue";
import {useSimulationStore} from "../../stores/simulation";

const props = defineProps({
  type: {
    type: String,
    required: true
  },
  child: {
    type: Boolean,
    required: false
  }
});

const val = ref(0);
const inputRange = ref(null);
const simulationStore = useSimulationStore();
const data: any = simulationStore.getData(props.type);
let childTypes = null;
if (props.type == simulationStore.TYPE_LIVING) {
  childTypes = simulationStore.getLivingChildTypes();
}

const avgPar = computed(() => {
  if (data.avg_par) {
    return 'left:' + data.avg_par.value + '%';
  }
  return '';

})

const avgValue = computed(()=>{
  return data.avg.value.toLocaleString();
})

onMounted(() => {
  updateTrack();
})
onUpdated(() => {
  simulationStore.update(props.type)
  updateTrack();
});

const toggleDetail = ()=>{
  document.querySelector('.range-child').classList.toggle('is-open');
}

const updateTrack = () => {
  const progress = (inputRange.value.value / inputRange.value.max) * 100;
  inputRange.value.style.background = `linear-gradient(to right, #004EA2 ${progress}%, #B9C3C9 ${progress}%)`;
};

</script>
<script setup lang="ts">
</script>